<template>
	<div class="o-dashboard">


		<c-tabs :tabs="tabs()" @selectTab="setTab">

			<c-tab v-if="tab == 'resellers'">

				<c-table
					ref="table"
					:columns="columns"
					:endpoint="'/api/resellers'"
					:placeholder="'Zoeken op reseller'">
				</c-table>
			</c-tab>

			<c-tab v-if="tab == 'eindklanten'">
				<c-table
					:filters="[ 
						{ name: 'reseller', label: 'Alle resellers', options: resellers }
					]"
					ref="table"
					:columns="columns"
					:endpoint="'/api/endcustomers'"
					:placeholder="'Zoeken op eindklant of reseller'">
				</c-table>
			</c-tab>

			<c-tab v-if="tab == 'eindgebruikers'">
				<c-table
					:filters="[ 
						{ name: 'client', label: 'Alle eindklanten', options: endClients }
					]"
					ref="table"
					:columns="columns"
					:endpoint="'/api/endusers'"
					:placeholder="'Zoeken op emailadres, eindgebruiker of eindklant'">
				</c-table>
			</c-tab>

			<c-tab v-if="tab == 'alle'">
				<c-table
					ref="table"
					:columns="columns"
					:endpoint="'/api/client-list'"
					:placeholder="'Zoeken op bedrijfsnaam of contactpersoon'">
				</c-table>
			</c-tab>

		</c-tabs>

		<c-new-customer
			v-show="modal"
			@close="modal=false"
			:size="'medium'"
			@added="load">
		</c-new-customer>

	</div>
</template>

<script>
import View from '@mixins/View';
import Form from '@mixins/Form';
import CTable from '@components/table/Table';
import CNewCustomer from '@app/modals/NewCustomer';
import CTabs from '@components/tab/Container';
import CTab from '@components/tab/Element';
import { mapGetters } from 'vuex';

export default {
	mixins: [ View, Form ],
	components: { CTable, CNewCustomer, CTabs, CTab },
	data() {
		return {
			modal: false,
			tab: 'resellers',
			// tabs: [
			// 	{ name:'resellers', label: 'Resellers' },
			// 	{ name:'eindklanten', label: 'Eindklanten' },
			// 	{ name:'eindgebruikers', label: 'Eindgebruikers' },
			// 	{ name:'alle', label: 'Alle' }
			// ]
		}
	},
	methods: {
		tabs(){
			let tabs = [];
			if(this.user.contact.client.client_type_id == this.$constants.client.REUZADO)
			{
				tabs = [
					{ name:'resellers', label: 'Resellers' },
					{ name:'eindklanten', label: 'Eindklanten' },
					{ name:'eindgebruikers', label: 'Eindgebruikers' },
					{ name:'alle', label: 'Alle' }
				]
			}
			else if(this.user.contact.client.client_type_id == this.$constants.client.RESELLER)
			{
				tabs = [
					{ name:'eindklanten', label: 'Eindklanten' },
					{ name:'eindgebruikers', label: 'Eindgebruikers' },
					{ name:'alle', label: 'Alle' }
				]
			}
			else if(this.user.contact.client.client_type_id == this.$constants.client.EINDKLANT)
			{
				tabs = [
					{ name:'eindklanten', label: 'Eindklanten' },
					{ name:'eindgebruikers', label: 'Eindgebruikers' },
				]
			}
			else
			{
				tabs = [
					{ name:'eindgebruikers', label: 'Eindgebruikers' },
				]
			}

			return tabs;
		},
		openModal() {
			this.modal = true;
		},
		load(){
			this.$refs.table.load();
		},
		setTab(tab) {
			this.tab = tab;
		},
        exportCrm() {
            const link = document.createElement('a');
			let filterParams = '';
            for (const [key, value] of Object.entries(this.$refs.table.selection.filters)) {
                if (value !== null && value !== '') {
                    filterParams += `&filters[${encodeURIComponent(key)}]=${encodeURIComponent(value)}`;
                }
            }

            link.href = '/api/exportcrmcsv?search=' + this.$refs.table.selection.search.all + '&sort=' + this.$refs.table.sort.column + '&order=' + this.$refs.table.sort.direction + '&tab=' + this.tab + filterParams;
            document.body.appendChild(link);
            link.click();
        }
	},
	created() {
		this.$store.dispatch('listener/on', {
			event: 'new-customer',
			listener: this.openModal
		});
        this.$store.dispatch('listener/on', {
            event: 'export',
            listener: this.exportCrm
        });
	},
	beforeUnmount() {
		this.$store.dispatch('listener/off', {
			event: 'new-customer',
			listener: this.openModal
		});
        this.$store.dispatch('listener/off', {
            event: 'export',
            listener: this.exportCrm
        });
	},
	computed: {
		...mapGetters({
			user: 'user/get'
		}),
		columns() {
			let columns;
			if(this.tab == 'alle') {
				columns = [
					{ name: 'name', label: 'Bedrijfsnaam', sortable: true, sort: true },
					{ name: 'client_type.name', label: 'Rol', sortable: true },
					{ name: 'visiting_address.street,visiting_address.number,visiting_address.city', label: 'Locatie', sortable: true },
					{ name: "id", label: '', component: 'CColumnButton', props: { route: 'customerDetail' }},
				];
			}
			else if(this.tab == "eindklanten") {
				columns = [
					{ name: 'name', label: 'Eindklant', sortable: true, sort: true },
					{ name: 'parent.name', label: 'Reseller', sortable: true },
					{ name: 'visiting_address.street,visiting_address.number,visiting_address.city', label: 'Locatie', sortable: true },
					{ name: "id", label: '', component: 'CColumnButton', props: { route: 'customerDetail' }},
				];
			}
			else if(this.tab == "resellers") {
				columns = [
					{ name: 'name', label: 'Reseller', sortable: true, sort: true },
					{ name: 'visiting_address.street,visiting_address.number,visiting_address.city', label: 'Locatie', sortable: true },
					{ name: "id", label: '', component: 'CColumnButton', props: { route: 'customerDetail' }},
				];
			}
			else if(this.tab == "eindgebruikers") {
				columns = [
                    { name: 'contact.first_name, contact.last_name ', label: 'Eindgebruiker', sortable: true, sort: true },
					{ name: 'parent.name', label: 'Eindklant', sortable: true },
					{ name: 'visiting_address.street,visiting_address.number,visiting_address.city', label: 'Locatie', sortable: true },
					{ name: "id", label: '', component: 'CColumnButton', props: { route: 'customerDetail' }},
				];
			}
			return columns;
		},
		resellers() {
			return this.$store.getters['filters/allResellers'];
		},
		endClients() {
			return this.$store.getters['filters/allEndClients'];
		}
	},
	beforeMount() {
		this.$store.dispatch('filters/fetchResellers');
		this.$store.dispatch('filters/fetchEndClients');
	},
}
</script>
